import React from "react";
import "../styles/Footer.css"; 

const Footer = () => {
  return (
    <footer className="footer">
      <p>Copyright © 2025 All Rights Reserved by JJRSF CLA CBT Platform</p>
     <p>💡<a href="https://wa.me/+2347070392387" target="_blank" rel="noopener noreferrer" style={{ color: 'black', textDecoration: 'none' }}
>
      Contact Developer
       </a>
      </p>
    </footer>
  );
};

export default Footer;
